import React, { FC } from 'react';

import {
  EstimatedRemainingWaitTimeCondition as EstimatedRemainingWaitTimeConditionType,
  NumberOperator,
} from 'src/actions/rules/condition';
import NumericConditionSection, { Option } from '../shared/NumericConditionSection';

type WaitTimeNumberSectionProps = {
  additionalOperators?: Option[];
  condition: EstimatedRemainingWaitTimeConditionType;
  index: number;
  isReadOnly?: boolean;
  onConditionOperatorChange?: Function;
  onUpdate: Function;
};

const WaitTimeNumberSection: FC<WaitTimeNumberSectionProps> = ({
  additionalOperators,
  condition,
  index,
  isReadOnly,
  onConditionOperatorChange,
  onUpdate,
}) => {
  // Convert from storage value (seconds) to display value (minutes). Round to 2nd decimal place.
  const convertToDisplayFn = (value: number) => {
    return Math.round((value / 60) * 100) / 100;
  };

  // Convert from display value to storage value (seconds)
  const convertFromDisplayFn = (displayValue: number) => {
    return displayValue * 60;
  };

  return (
    <NumericConditionSection
      additionalOperators={additionalOperators}
      condition={condition}
      convertFromDisplayFn={convertFromDisplayFn}
      convertToDisplayFn={convertToDisplayFn}
      excludedOperators={[NumberOperator.Equal]}
      index={index}
      isReadOnly={isReadOnly}
      limitDecimals={2}
      onConditionOperatorChange={onConditionOperatorChange}
      onUpdate={onUpdate}
      requirePositive={true}
      showExclusion={false}
      showValidationTooltip={true}
      unitLabel="Minutes"
    />
  );
};

export default WaitTimeNumberSection;
